import { magnetMixin } from "@/mixins/magnetMixin";
export const voorbeeldPrognosesMixin = {
  mixins: [ magnetMixin ],
  data() {
    return {
      legeinspectie: {
        config: {
          jaren: 15,
          jaar: 2016,
          showModeratorPanel: false,
          bouwjaar: 1980,
          smalltable: true,
          modus: "Detail",
          footClone: false,
          rows: [
            {
              label: "Correctief",
              standaard: 0
            },
            {
              label: "Preventief",
              standaard: 0
            },
            {
              label: "Werkelijk"
            }
          ]
        },
        moderators: [
          this.createMagnet(2020, -3, 2, false),
          this.createMagnet(2028, -2, 1, false)
        ],
        omschrijving: "Nieuwe prognose",
        onderdelen: []
      },
      defaultinspectie: {
        config: {
          jaren: 10,
          jaar: 2016,
          showModeratorPanel: true,
          bouwjaar: 1980,
          smalltable: true,
          modus: "Positie",
          footClone: false,
          rows: [
            {
              label: "Correctief",
              2019: 150,
              2020: 140,
              standaard: 99
            },
            { label: "Preventief", 2020: 500, 2024: 1000, standaard: 600 },
            {
              label: "Werkelijk",
              2019: 1500,
              2018: 450.2,
              2017: 150
            }
          ]
        },
        moderators: [
          this.createMagnet(2020, -3, 2),
          this.createMagnet(2028, -2, 1, false)
        ],
        omschrijving: "Dit is een voorbeeld prognose.",
        onderdelen: [
          {
            title: "Liftcabine",
            short_description: "80.31",
            long_description: "",
            multiplier: "e.ASCH * 4",
            jaar: 2020,
            revisie: 150,
            cyclus: 3,
            children: [
              {
                title: "Cabineframe vang incl. sloffen",
                short_description: "",
                long_description: "",
                revisie: 200,
                jaar: null,
                children: [
                  {
                    title: "Cabineframe vang incl. sloffen",
                    short_description: "",
                    long_description: "",
                    gebreken: [],
                    jaar: null
                  },
                  {
                    title: "Cabinetoegang",
                    short_description: "",
                    long_description: "",
                    revisie: 150,
                    cyclus: 3,
                    jaar: 2021
                  }
                ]
              },
              {
                title: "Cabinetoegang",
                short_description: "",
                long_description: "",
                jaar: 2017
              }
            ]
          },
          {
            title: "Constructies in de schacht",
            short_description: "80.32",
            long_description: "",
            jaar: 2016,
            children: [
              {
                title: "Cabineframe",
                short_description: "vang incl. sloffen",
                long_description: "",
                jaar: null
              },
              {
                title: "Cabinetoegang",
                short_description: "",
                long_description: "",
                jaar: 2017
              }
            ]
          },
          {
            title: "Hydraulisch",
            short_description: "80.33.2",
            long_description: "",
            jaar: 2016,
            children: [
              {
                title: "Cabineframe",
                short_description: "vang incl. sloffen",
                long_description: "",
                jaar: null
              },
              {
                title: "Cabinetoegang",
                short_description: "",
                long_description: "",
                jaar: 2017
              }
            ]
          },
          {
            title: "Besturing, Regeling, Signalering",
            short_description: "80.34",
            long_description: "",
            jaar: 2016,
            //_showDetails: true,
            children: [
              {
                title: "Cabineframe",
                short_description: "vang incl. sloffen",
                long_description: "",
                jaar: null
              },
              {
                title: "Cabinetoegang",
                short_description: "",
                long_description: "",
                jaar: 2017
              }
            ]
          },
          {
            title: "Schachtoegangen",
            short_description: "80.35",
            long_description: "",
            jaar: 2016,
            //_showDetails: true,
            children: [
              {
                title: "Cabineframe",
                short_description: null,
                long_description: "",
                jaar: null
              },
              {
                title: "Cabinetoegang",
                short_description: null,
                long_description: null,
                jaar: 2017
              }
            ]
          },
          {
            title: "Overige",
            short_description: "80.90",
            long_description: null,
            jaar: 2016,
            //_showDetails: true,
            children: [
              {
                title: "Cabineframe",
                short_description: null,
                long_description: null,
                jaar: null
              },
              {
                title: "Cabinetoegang",
                short_description: null,
                long_description: null,
                jaar: 2017
              }
            ]
          }
        ]
      }
    };
  }
};
